module.exports = __webpack_public_path__ + "img/knu_gallery18.711e092d.jpg";